import React, { PureComponent } from 'react';
import { MapPoint } from 'types';
import { getMapsImage, getMapsImagePolyline } from './utils';

// Components

interface MapImageProps {
  width: number;
  height: number;
  point?: Object;
  path?: MapPoint[];
}
export default class MapImage extends PureComponent<MapImageProps> {
  static defaultProps = {
    width: 800,
    height: 400
  };
  render() {
    const { className, image, point, path, width, height } = this.props;

    const url = image && `http://storage.googleapis.com/${image.bucket}/${image.path}`;
    return (
      <div
        className={className}
        style={{
          width: '100%',
          backgroundPosition: '50% 50%',
          backgroundSize: 'cover',
          backgroundImage: `url(${url})`
          // backgroundImage: `url(${
          //   path ? getMapsImagePolyline(path, width, height) : getMapsImage(point, width, height)
          // })`
        }}
      />
    );
  }
}
